/* globals translation */
const quantityUpdateTrigger = () => {
  if (document.body.classList.contains('is-b2b')) {
    return;
  }

  const qtyFields = Array.from(document.querySelectorAll('.product-quantity .quantity .qty'));
  const updateButton = document.querySelector('[name="update_cart"]');
  const subscriptionOptions = Array.from(document.querySelectorAll('.hidden-checkbox'));

  qtyFields.forEach((qtyField) => {
    qtyField.addEventListener('change', () => {
      setTimeout(() => {
        updateButton.click();
      }, 10);
    });
  });

  subscriptionOptions.forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
      setTimeout(() => {
        updateButton.click();
      }, 10);
    });
  });
};

if (document.body.classList.contains('woocommerce-cart')) {
  // Recursive: Loop through till the "bundled_table_item" class does not exist on the next element
  const toggleDisplayAndCheckNext = (row) => {
    row.classList.toggle('display');

    // Continue to trigger this function until it finds a tr without .bundled_table_item
    if (row.nextElementSibling.classList.contains('bundled_table_item')) {
      toggleDisplayAndCheckNext(row.nextElementSibling);
    }
  };

  // Create toggle for main bundle products in cart
  const createButton = () => {
    Array.from(document.querySelectorAll('.woocommerce-cart-form table.woocommerce-cart-form__contents tbody tr.cart_item')).forEach((row) => {
      if (row.classList.contains('bundle_table_item')) {
        // Skip if button exists in row
        if (row.getElementsByClassName('toggle-bundled-items')[0]) {
          return;
        }

        // Create the toggle button
        const createdToggleElement = document.createElement('button');
        createdToggleElement.className = 'toggle-bundled-items';
        createdToggleElement.innerText = translation.show_products;

        // Add the toggle button to product name td
        const title = row.querySelector('td.product-data .product-data-name-price .product-data-name');
        title.append(createdToggleElement);

        createdToggleElement.addEventListener('click', (event) => {
          event.preventDefault();

          createdToggleElement.classList.toggle('open');

          if (createdToggleElement.classList.contains('open')) {
            createdToggleElement.innerText = translation.hide_products;
          } else {
            createdToggleElement.innerText = translation.show_products;
          }

          toggleDisplayAndCheckNext(row);
        });
      }
    });
  };

  // Trigger det insert button function on load
  createButton();

  // Trigger det insert button when the cart is updated
  jQuery(document.body).on('updated_cart_totals', createButton);

  const checkActiveShipping = () => {
    Array.from(document.querySelectorAll('input.shipping_method')).forEach((inputField) => {
      if (inputField.checked) {
        inputField.parentNode.classList.add('checked');
      }

      inputField.addEventListener('change', () => {
        inputField.parentNode.classList.add('checked');
      });
    });
  };

  checkActiveShipping();

  jQuery(document.body).on('updated_cart_totals', checkActiveShipping);

  // Toggle display coupons
  const toggleCartDiscount = () => {
    const cartCouponToggleButton = document.getElementById('toggle-cart-coupons');
    const cartCouponContainer = document.querySelector('td.actions .coupon-inner');
    cartCouponToggleButton.addEventListener('click', (event) => {
      event.preventDefault();
      cartCouponToggleButton.remove();
      cartCouponContainer.classList.remove('hidden');
      cartCouponContainer.querySelector('.input-text').focus();
    });
  };

  toggleCartDiscount();
  jQuery(document.body).on('updated_cart_totals', toggleCartDiscount);

  quantityUpdateTrigger();
}

const reorderCartTable = () => {
  // Fetch all shop table's
  const tables = document.querySelectorAll('table.shop_table');

  tables.forEach((table) => {
    const tbody = table.querySelector('tbody');

    tbody.querySelectorAll('tr').forEach((row) => {
      if (row.classList.contains('free-product') || row.querySelector('td.actions')) {
        // If matching the criteria's, move it to the end
        tbody.appendChild(row);
      }
    });
  });
};

reorderCartTable();

jQuery(document.body).on('updated_cart_totals', reorderCartTable);
jQuery(document.body).on('updated_cart_totals', quantityUpdateTrigger);

jQuery('body').on('update_checkout', () => {
  reorderCartTable();
  quantityUpdateTrigger();

  // Need to trigger twice since it get's changed multiple times when doing changes in klarna
  setTimeout(() => {
    reorderCartTable();
    quantityUpdateTrigger();
  }, 2000);
});
